export default {
  COLOR: 'COLOR',
  DATE: 'DATE',
  EVENT: 'EVENT',
  BOOLEAN: 'BOOLEAN',
  SELECT: 'SELECT',
  NUMBER: 'NUMBER',
  STRING: 'STRING'
};



// WEBPACK FOOTER //
// ./src/constants/widgetDataTypes.js